var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245.572,
    height: 392.42,
    viewBox: "0 0 245.572 392.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8415",
    "data-name": "Path 8415",
    d: "M159.082,415.23c2.26,13.77,16.17,13.77,16.17,13.77s6.73-13.88,14-28.32,14.85-29.21,16.92-31.59a12.189,12.189,0,0,0,1.46-3.33c3.4-10.15,9.93-40.38,14.73-66.53,3.54-19.23,6.14-36.25,5.88-41.42,0-.66-.07-1.37-.12-2.1-.41-7.43-1.17-18.21-1.79-26.75-.57-7.67-1-13.53-1-13.53l-31.66,15.77h0l-19.91,9.92s.92,3.35,2.32,8.56c4.35,16.08,13.37,49.91,14.5,57.51a29.3,29.3,0,0,1-.51,7.93h0c-.61,3.76-1.62,8.28-2.8,13-2,7.77-4.4,16.06-6.32,22.33-1.87,6.06-3.25,10.23-3.25,10.23Z",
    transform: "translate(-159.082 -215.43)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M99.743,141.09l1.25,29,.49.33c2.47,1.66,13.88,9.15,24.05,12.89,4,1.47,7.81,2.36,10.81,2.1,11.62-1,14.26-7.29,14.26-7.29.75-3.52-2.93-8-8.62-12.57-6-4.83-14.13-9.8-21.69-14C109.393,145.5,99.743,141.09,99.743,141.09Z",
    transform: "translate(-99.743 -141.09)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M144.881,242.81s2.54,3,18.24,7.72a218.39,218.39,0,0,0,31.6,6.71l2.53-11.44,2.06,11.44a67.721,67.721,0,0,0,15.83-8.11L213.9,229.6c-.24-7.47,2.25-32.14,9.75-48.74s4.95-37.21-1.25-39.77c-4.19-1.73-17.26-3.92-25.31-5.17-3.88-.6-6.6-1-6.6-1a104.939,104.939,0,0,0-25.17,3.11c-11.74,2.92-19.43,7.08-19.43,8.7,0,1.45,1.69,18.11,3.2,33.06,1.2,11.94,2.28,22.77,2.28,23.88,0,.73-.56,4.4-1.35,9.23h0C148.141,224.53,144.881,242.81,144.881,242.81Z",
    transform: "translate(-144.881 -134.92)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-151",
    transform: "translate(-50.967 51.745) rotate(-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8411",
    "data-name": "Path 8411",
    d: "M217.956,411.68s-4.11,8.79-6.16,11-2.62,7.47-2.62,7.47v4.11l2.24,4.74,3-.75,2.39,7.1s4.88,13.27,13.3,13.64,2.63-10.31.93-17.99-2.26-15.7-.94-20S217.956,411.68,217.956,411.68Z",
    transform: "translate(-141.099 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8412",
    "data-name": "Path 8412",
    d: "M159.082,415.23c2.26,13.77,16.17,13.77,16.17,13.77s6.73-13.88,14-28.32,14.85-29.21,16.92-31.59a12.189,12.189,0,0,0,1.46-3.33c3.4-10.15,9.93-40.38,14.73-66.53,3.54-19.23,6.14-36.25,5.88-41.42,0-.66-.07-1.37-.12-2.1-.41-7.43-1.17-18.21-1.79-26.75-.57-7.67-1-13.53-1-13.53l-31.66,15.77h0l-19.91,9.92s.92,3.35,2.32,8.56c4.35,16.08,13.37,49.91,14.5,57.51a29.3,29.3,0,0,1-.51,7.93h0c-.61,3.76-1.62,8.28-2.8,13-2,7.77-4.4,16.06-6.32,22.33-1.87,6.06-3.25,10.23-3.25,10.23Z",
    transform: "translate(-84.705 -75.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(74.377 140.177)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8413",
    "data-name": "Path 8413",
    d: "M164.98,415.23C167.24,429,181.15,429,181.15,429s6.73-13.88,14-28.32,14.85-29.21,16.92-31.59a12.189,12.189,0,0,0,1.46-3.33c3.4-10.15,9.93-40.38,14.73-66.53-3.54-2.4-6.74-5.45-7.65-9-2.3-9-2.36-10.81-2.36-10.81l2.36-4.4-7.08,2-17.59,38.07h0c-.61,3.76-1.62,8.28-2.8,13-2,7.77-4.4,16.06-6.32,22.33-1.87,6.06-3.25,10.23-3.25,10.23Z",
    transform: "translate(-164.98 -215.43)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8414",
    "data-name": "Path 8414",
    d: "M159.25,241.11s.92,3.35,2.32,8.56c25.44,12.1,42.74,9,42.74,9l-4.08,4.44c3.91-.59,9.65-4.55,13.41-7.44-.41-7.43-1.17-18.21-1.79-26.75-9,.34-21.34,1-32.68,2.24h0Z",
    transform: "translate(-144.63 -215.43)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8416",
    "data-name": "Path 8416",
    d: "M159.082,415.23c2.26,13.77,16.17,13.77,16.17,13.77s6.73-13.88,14-28.32,14.85-29.21,16.92-31.59a12.189,12.189,0,0,0,1.46-3.33c3.4-10.15,9.93-40.38,14.73-66.53,3.54-19.23,6.14-36.25,5.88-41.42,0-.66-.07-1.37-.12-2.1-.41-7.43-1.17-18.21-1.79-26.75-.57-7.67-1-13.53-1-13.53l-31.66,15.77h0l-19.91,9.92s.92,3.35,2.32,8.56c4.35,16.08,13.37,49.91,14.5,57.51a29.3,29.3,0,0,1-.51,7.93h0c-.61,3.76-1.62,8.28-2.8,13-2,7.77-4.4,16.06-6.32,22.33-1.87,6.06-3.25,10.23-3.25,10.23Z",
    transform: "translate(-84.705 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8417",
    "data-name": "Path 8417",
    d: "M179.74,350.43c1.18,13.92,3.62,34.7,8.33,50.24,7.18-14.33,14.85-29.21,16.92-31.59a12.191,12.191,0,0,0,1.46-3.33L186.06,328.1C184.1,335.87,181.66,344.16,179.74,350.43Z",
    transform: "translate(-83.553 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8418",
    "data-name": "Path 8418",
    d: "M169.695,446.45c-.84-7.48-15.82-2.26-20.83-3.37a24.061,24.061,0,0,1-8.77-4.11l-14.58,3s.46,15.71,2.23,19.29a33.34,33.34,0,0,0,4.24,6.6l14.05-1.12.67-2.74,5.92-1S170.3,451.82,169.695,446.45Z",
    transform: "translate(7.412 -75.253)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8419",
    "data-name": "Path 8419",
    d: "M162.94,445.24c-2.39-2.65-8.78,1.74-13.37,5.1a58.637,58.637,0,0,0-8,6.7l-7.4,2.24.11,2.23s-11.27,4.16-8.7,6.4,14.05-1.12,14.05-1.12l.67-2.74,5.92-1S167.71,450.53,162.94,445.24Z",
    transform: "translate(13.807 -75.253)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M151.724,222.85s-5,22-3.49,41.56,30.39,92.47,32.39,101.59,24,81.81,24,81.81,12.11-8.94,22.32-6.88c0,0-4.79-23.33-7.11-32.86s-7.18-32.79-7-38.11-10.65-24.18-8.22-26.95-7.73-60-8.13-69.53-13.22-15.68-13.22-15.68",
    transform: "translate(-72.257 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M99.743,141.09l1.25,29,.49.33c2.47,1.66,13.88,9.15,24.05,12.89,4,1.47,7.81,2.36,10.81,2.1,11.62-1,14.26-7.29,14.26-7.29.75-3.52-2.93-8-8.62-12.57-6-4.83-14.13-9.8-21.69-14C109.393,145.5,99.743,141.09,99.743,141.09Z",
    transform: "translate(52.194 -75.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(151.937 65.837)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M108.5,170.39c2.47,1.66,13.88,9.15,24.05,12.89a91.509,91.509,0,0,0,6.07-10.51c2-4.36,6.26-6.37,10.38-7.25-6-4.83-14.13-9.8-21.69-14-1.26,9.22-9.47,14.51-9.47,14.51,2.38-5.49,0-17.73-1.54-12.46C115.31,157.08,111.21,165.26,108.5,170.39Z",
    transform: "translate(-106.8 -141.09)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M99.743,141.09l1.25,29,.49.33c2.47,1.66,13.88,9.15,24.05,12.89,4,1.47,7.81,2.36,10.81,2.1,11.62-1,14.26-7.29,14.26-7.29.75-3.52-2.93-8-8.62-12.57-6-4.83-14.13-9.8-21.69-14C109.393,145.5,99.743,141.09,99.743,141.09Z",
    transform: "translate(52.194 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M144.881,242.81s2.54,3,18.24,7.72a218.39,218.39,0,0,0,31.6,6.71l2.53-11.44,2.06,11.44a67.721,67.721,0,0,0,15.83-8.11L213.9,229.6c-.24-7.47,2.25-32.14,9.75-48.74s4.95-37.21-1.25-39.77c-4.19-1.73-17.26-3.92-25.31-5.17-3.88-.6-6.6-1-6.6-1a104.939,104.939,0,0,0-25.17,3.11c-11.74,2.92-19.43,7.08-19.43,8.7,0,1.45,1.69,18.11,3.2,33.06,1.2,11.94,2.28,22.77,2.28,23.88,0,.73-.56,4.4-1.35,9.23h0C148.141,224.53,144.881,242.81,144.881,242.81Z",
    transform: "translate(-70.504 -75.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(74.377 59.667)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M217.07,203.69c0,.73-.56,4.4-1.35,9.23,8.25-7.26,8.29-22.09,8.29-22.09l-3.5.22c4.34-2.71,3.84-16.56,2.71-13.33s-4.67,2.21-4.67,2.21l-3.76-.12C215.99,191.75,217.07,202.58,217.07,203.69Z",
    transform: "translate(-210.54 -134.92)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8427",
    "data-name": "Path 8427",
    d: "M169.1,155.36l-5,15.13,32.39,29.7.89-3.62,15.45-29.28-6.51-11.93,4.51-4.67s-7-9.45-14.88-14.77c-3.88-.6-6.6-1-6.6-1a104.94,104.94,0,0,0-25.17,3.11c-2.69,4-5,15.58-5,15.58Z",
    transform: "translate(-143.75 -134.92)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M144.881,242.81s2.54,3,18.24,7.72a218.39,218.39,0,0,0,31.6,6.71l2.53-11.44,2.06,11.44a67.721,67.721,0,0,0,15.83-8.11L213.9,229.6c-.24-7.47,2.25-32.14,9.75-48.74s4.95-37.21-1.25-39.77c-4.19-1.73-17.26-3.92-25.31-5.17-3.88-.6-6.6-1-6.6-1a104.939,104.939,0,0,0-25.17,3.11c-11.74,2.92-19.43,7.08-19.43,8.7,0,1.45,1.69,18.11,3.2,33.06,1.2,11.94,2.28,22.77,2.28,23.88,0,.73-.56,4.4-1.35,9.23h0C148.141,224.53,144.881,242.81,144.881,242.81Z",
    transform: "translate(-70.504 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8430",
    "data-name": "Path 8430",
    d: "M185.97,130.82s10.45,2.52,23.71,15.93l-4.51,5.37,4.51,7.66s-7.84,24.85-13.82,34l1.12,8.41-29.46-36.15,4-11.94-10.39-2.56,2.43-14.17S170.56,126.76,185.97,130.82Z",
    transform: "translate(-68.173 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    d: "M192.13,134.94s6.73,8.34,8.23,17.43S194,190.83,194,190.83s-12.33-35-24.66-55.89Z",
    transform: "translate(-67.253 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8432",
    "data-name": "Path 8432",
    d: "M182.52,147.26l-2.8,10.09,1.65,23.73-2.4,9.75-3.63-9.79,2-23.13-5-9.9S179.38,145.77,182.52,147.26Z",
    transform: "translate(-52.223 -75.253)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8433",
    "data-name": "Path 8433",
    d: "M199.863,141.91s-4-9.6-11.36-13.4a16.37,16.37,0,0,0-14.37,0l-5,6.43,15.44,20.42,8.47-7.23,7.11,4.24S201.262,144.71,199.863,141.91Z",
    transform: "translate(-67.066 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8434",
    "data-name": "Path 8434",
    d: "M168.71,129.51l16.67,16.63s2.06-6.17,3.18-7.85c.22-.33.55-.86.94-1.51,1.59-2.67,4.17-7.27,4.17-7.27l-5.88-5.3L173,110.89v10.34C173,122.11,168.71,129.51,168.71,129.51Z",
    transform: "translate(-59.743 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8435",
    "data-name": "Path 8435",
    d: "M250.848,268.78l36,46.82a4.73,4.73,0,0,1,.87,3.83l-8.86,42.09a1.85,1.85,0,0,1-3.33.66l-31.96-46.73a4.72,4.72,0,0,1-.79-3.16l4.79-42.59a1.85,1.85,0,0,1,3.28-.92Z",
    transform: "translate(-227.931 -75.253)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    d: "M133.713,178.09c-.56,6.82-6.07,12.62-27.28,11.12,0,0-6.07-4.58-6.54-9.44s2.34-7,2.34-7l14.1-3.09a11.27,11.27,0,0,1,4-1.86",
    transform: "translate(69.084 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M122.417,172.77s7.85-.1,10,6.54-5,9.25-5,9.25-5.84-2.15-6.4-7.9S122.417,172.77,122.417,172.77Z",
    transform: "translate(48.899 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8438",
    "data-name": "Path 8438",
    d: "M123.309,176.3s1.47-1.2,2.12-1.58,4.92-.42,7.6.78c3.32,1.47,5.88,8.35.56,10.72s-5.42-.15-5.42-.15Z",
    transform: "translate(42.678 -75.253)",
    fill: "#962cc6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8439",
    "data-name": "Path 8439",
    d: "M127.56,177.74a82.329,82.329,0,0,0,8.09-1.7s7.56,0,8,5.17c.39,4.17-1.48,5.91-6.9,7.35Z",
    transform: "translate(31.377 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M149.416,177.91c-4.86-1.12-13.08,3-14.92,4.48-1.12.9-.9,9.39-.38,10.53.94,2.05,5.18,2.86,5.18,2.86,3.33,1.93,7.58,1.2,9,.06,1-.79,1.09-5,1.09-5s6.55.36,7.5-3.46",
    transform: "translate(12.06 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    d: "M145.07,190.83a3.39,3.39,0,0,1-3.91-.59",
    transform: "translate(16.407 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    "data-name": "Path 8442",
    d: "M146.7,191.05s-.73,2.43-3,2.43",
    transform: "translate(12.237 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    d: "M150.841,196.71a8.88,8.88,0,0,1-5.72-3.79c-.26-.73.56-6.11.56-6.11",
    transform: "translate(6.726 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M154.133,196.8a10.69,10.69,0,0,1-5.47-3.57c-.39-.71,0-7.85,0-7.85",
    transform: "translate(0.014 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M128.05,175.13c0,.65,1.78,1.06,3.86.91s3.73-.8,3.69-1.45-1.78-1.07-3.86-.92S128,174.48,128.05,175.13Z",
    transform: "translate(38.986 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M264.73,268.07H250.24l26.93,94.82h15.98l2.7-39.07Z",
    transform: "translate(-243.453 -75.253)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M265.658,268.78l36,46.82a4.7,4.7,0,0,1,.88,3.83l-8.86,42.09a1.85,1.85,0,0,1-3.33.66l-31.93-46.73a4.72,4.72,0,0,1-.79-3.16l4.72-42.59a1.85,1.85,0,0,1,3.31-.92Z",
    transform: "translate(-257.601 -75.253)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M275.931,299s1.37-8.35,0-11.53-10.34-12.95-12.33-12.61-4.61,6.82-4.61,6.82,1.38,3.49,3.49,3.37c0,0,.32-2.37,1.7-2.74s4.74,4.07,6.1,6.85c1,2.11-.26,7.35-.26,7.35S272.211,300.39,275.931,299Z",
    transform: "translate(-232.894 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M260.539,260.08s-5.8,15.76-5.41,18.54,3.57,10.47,4.78,11a6,6,0,0,0,5.44-.49s-2.52-3.37,0-6.54c.93-1.17,5.65,4.85,5.65,4.85s4.49-.93,4.49-3.73-1.78-8-2.48-11.21a33.149,33.149,0,0,0-1.44-5l1.44-4.74Z",
    transform: "translate(-227.962 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M265.678,146.75s8.21,14.15,6.85,35.55c0,0-15.7,27.45-18.69,33.12s-6.35,17.26-7.47,21-7.28,16.45-9.52,26.16l-.94,4.66s-11.21,2.12-15.7-3.14c0,0,14.2-48.6,14.2-50.85s4.86-11,4.86-11S255.458,162.84,265.678,146.75Z",
    transform: "translate(-190.251 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8451",
    "data-name": "Path 8451",
    d: "M258.1,282.57c1.79-1.06,5.4,3.05,7.15,1.43",
    transform: "translate(-220.713 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8452",
    "data-name": "Path 8452",
    d: "M274.4,285.37s-1.49,2-2.49,0-1.7-1.08-3.34-3",
    transform: "translate(-240.333 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8453",
    "data-name": "Path 8453",
    d: "M179.29,257.24s-7.53,8.62-12,12.42",
    transform: "translate(-43.943 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x1: 11.13,
    y2: 5.41,
    transform: "translate(124.217 192.817)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8454",
    "data-name": "Path 8454",
    d: "M185.41,262s10.86-1.75,26.4,5.65",
    transform: "translate(-94.583 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8455",
    "data-name": "Path 8455",
    d: "M175.02,343s-3.55,2.45-4.73,10.76",
    transform: "translate(-42.673 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8456",
    "data-name": "Path 8456",
    d: "M169.31,431.65s-7.22-4.58-18-3",
    transform: "translate(-17.983 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M175.906,202.2s-2.89,24-1.85,36.18",
    transform: "translate(-47.099 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8458",
    "data-name": "Path 8458",
    d: "M222.12,174.49s-1.63,7.47-7.67,10.89",
    transform: "translate(-133.933 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8459",
    "data-name": "Path 8459",
    d: "M223.29,187.35a11.67,11.67,0,0,1-5-.54",
    transform: "translate(-138.943 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8460",
    "data-name": "Path 8460",
    d: "M146.44,162.88a48,48,0,0,1-5.28,9.16",
    transform: "translate(15.037 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M120.92,165.07s-1.55.19-4.16,5.42",
    transform: "translate(64.957 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8462",
    "data-name": "Path 8462",
    d: "M168.72,120.86s2.09,10.84,12.52,15.92c1.59-2.67,4.17-7.27,4.17-7.27l-5.88-5.3C175.86,122.1,171.96,120.68,168.72,120.86Z",
    transform: "translate(-51.493 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8463",
    "data-name": "Path 8463",
    d: "M153.591,117.29a28.39,28.39,0,0,0,1.71,4.85c2.19,4.49,9.77,10.66,15.43,12.74,2,.72,9.25-5.54,14-14.63,1.22-2.34,1.39-8.22,2.85-10.5,3.5-5.47,3.51-10.1,2.64-15-3-17.19-33.43-20.12-37.92-12.77-2.16,3.56-5.59,13.75,1,28.78",
    transform: "translate(-37.524 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M169.84,106.9s-4.81-2-7.78,0",
    transform: "translate(-29.263 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M150.7,107.52s3.24-2.36,5.38-1.89",
    transform: "translate(-4.143 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M166.021,110.35c-.21.8,0,1.55.46,1.67s1-.42,1.23-1.22,0-1.55-.46-1.67S166.231,109.55,166.021,110.35Z",
    transform: "translate(-31.104 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M155.24,110.66c-.22.8,0,1.55.46,1.67s1-.42,1.22-1.22,0-1.55-.46-1.67S155.45,109.87,155.24,110.66Z",
    transform: "translate(-9.523 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8468",
    "data-name": "Path 8468",
    d: "M159.818,110.58c-.56,1,1.87,7.41,1.93,8.28s-1,2.12-3.11,2.24-1.68-.12-2.12.13",
    transform: "translate(-15.631 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M169.53,124.87s-4.67.22-7.78-1.34",
    transform: "translate(-28.643 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M163.671,95.81l.87,5.73s-8,5.73-8.22,7.35a7.26,7.26,0,0,0,0,2.62l-1.74,1.62s-.75-6.26-2.25-7.11-4.28,8.92-4.28,8.92-4.32-5.61-4.35-11.74c-.07-14.61,3.4-22.17,9.26-25a8.9,8.9,0,0,1,3.61-2.83c2.24-.87,25.43,3.41,27.48,2.83a20.75,20.75,0,0,0,4.53-2.2v5.35l5.16-1.35s-.67,8.35-4.66,11l4.66-.75a46.78,46.78,0,0,1-6,6.32C185.1,98.68,175.131,100.42,163.671,95.81Z",
    transform: "translate(-34.804 -75.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M193.671,108s-4.85-5.6-6.72-4.73-2.37,4.36-1.25,6.48,4.11,10,6.85,6.13",
    transform: "translate(-76.145 -75.253)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M212.79,227.57V224s-12.07-.59-16-2.57l-1,3.07",
    transform: "translate(-105.943 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M161.13,227.57v-3.06a10.61,10.61,0,0,0,6.16-3.07v3.07",
    transform: "translate(-25.783 -75.253)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.44899148b78d9a338b1dba7043b13b84.svg";
export { ForwardRef as ReactComponent };